import {LitElement, html} from 'lit';
import {customElement} from 'lit/decorators.js';
import {Router} from '@lit-labs/router';
import {routes} from './router/routes.js';
import './components/landing-page.js';

/**
 * Root Application Component
 * This is the top-level component that mounts the application
 * and manages client-side routing
 */
@customElement('app-root')
export class AppComponent extends LitElement {
  // Disable Shadow DOM to use global Tailwind styles
  protected createRenderRoot() {
    return this;
  }

  // Initialize Router at the application root
  private router = new Router(this, routes);

  render() {
    return html`${this.router.outlet()}`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'app-root': AppComponent;
  }
}
